import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "About the Diploma", "id": "about-diploma" },
    { "name": "Course Objectives", "id": "course-objectives" },
    { "name": "Admission Eligibility", "id": "eligibility" },
    { "name": "Curriculum", "id": "curriculum" },
    { "name": "Time Table", "id": "timetable" },
    { "name": "Facilities", "id": "facilities" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>Sanskrit language is an unparalleled treasure of Indian intellect and culture. The nature of Sanskrit is vast and comprehensive. Countless Indians wish to learn Sanskrit for the preservation and strengthening of their Indian identity. The aim is to impart knowledge of the Sanskrit language and the science embedded within it through the simplest process. With the conception of this great objective, the university has launched the **Sanskrit Language Proficiency Diploma** course to provide Sanskrit study facilities to Sanskrit enthusiasts from various sectors of society.</p>
            <p>Proficiency in the Sanskrit language means the ability to communicate effectively and express oneself in Sanskrit with **correct pronunciation, grammar, and writing**. It involves understanding the rules and structures of the language and using them correctly. To achieve Sanskrit language proficiency, **practice, regular study, and interaction with the Sanskrit language** are essential. You can also enhance your language proficiency by using various Sanskrit learning resources.</p>
            <p>The Sanskrit Language Proficiency Diploma is a special course to gain proficiency in the Sanskrit language. This diploma program is designed to comprehensively develop knowledge of the Sanskrit language and literature, enabling learners to gain a deeper understanding of Indian languages and literature.</p>
            <p>This university offers a **one-year Sanskrit Language Proficiency Diploma** course. The objectives of this course are as follows:</p>
        </>
    ),
    "course-objectives": (
        <>
            <h5>Course Objectives:</h5>
            <ul>
                <li>To attain proficiency in the Sanskrit language and literature.</li>
                <li>To develop an understanding of Indian culture and history by learning the Sanskrit language.</li>
                <li>To develop the ability to study texts written in Sanskrit such as the Vedas, Puranas, Ramayana, Mahabharata, and Upanishads.</li>
                <li>To learn mathematics, science, and other languages by learning Sanskrit.</li>
                <li>Sanskrit language is a thought, culture, and tradition that embodies the spirit of global welfare and peace.</li>
            </ul>
        </>
    ),
    "eligibility": (
        <>
            <h5>Course Admission Eligibility</h5>
            <ul>
                <li>The Sanskrit Language Proficiency Diploma course is a one-year, two-semester program. Admission to this course takes place in June-July every year.</li>
                <li>For admission to the Sanskrit Language Proficiency Diploma course, it is mandatory to have passed the Senior Secondary Certificate 10+2 in Arts, Commerce, or Science, or an Intermediate or equivalent examination from a recognized board.</li>
            </ul>
        </>
    ),
    "curriculum": (
        <>
            <h5>Curriculum</h5>
            <h6>Sanskrit Language Proficiency Diploma Course Structure</h6>
            <h6>First Semester</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Subject Code</th>
                            <th>Paper Name</th>
                            <th>Max. Marks</th>
                            <th>Duration</th>
                            <th>Credits</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>AV-1.1</td>
                            <td>Sanskrit Teaching (Part I)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.2</td>
                            <td>Gita Teaching (Part I)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.3</td>
                            <td>Introduction to Sanskrit Stories (Part I)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-1.4</td>
                            <td>Introduction to Sanskrit Stories (Part II)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h6>Second Semester</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Subject Code</th>
                            <th>Paper Name</th>
                            <th>Max. Marks</th>
                            <th>Duration</th>
                            <th>Credits</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>AV-1.2</td>
                            <td>Sanskrit Teaching (Part II)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.2</td>
                            <td>Gita Teaching (Part II)</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.3</td>
                            <td>Sanskrit Sentence Structure</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                        <tr>
                            <td>D-SBD-2.4</td>
                            <td>Practical</td>
                            <td>100</td>
                            <td>60 hours</td>
                            <td>04</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    ),
    "timetable": (
        <>
            <h5>Time Table</h5>
            <ul>
                <li>The time table is prepared according to the curriculum at the beginning of each semester.</li>
            </ul>
        </>
    ),
    "facilities": (
        <>
            <h5>Facilities</h5>
            <ul>
                <li>Providing practical and functional knowledge of the Sanskrit language to students.</li>
                <li>Imparting knowledge of the scientific tradition of the Sanskrit language.</li>
                <li>Guidance for competitive examinations.</li>
                <li>Providing knowledge of Sanskrit literature.</li>
            </ul>
        </>
    ),
    "achievements": (
        <>
            <h5>Achievements</h5>
            <ul>
                <li>As this is a new course in the university, there are no achievements to date.</li>
            </ul>
        </>
    ),
    "contact": (
        <>
            <h5>Contact</h5>
            <h6>Departmental Academic Members</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Name</th>
                            <th>Post</th>
                            <th>Contact No.</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Dr. Chandra Kant</td>
                            <td>Diploma Coordinator Assistant Professor (Contractual)</td>
                            <td>7018781438</td>
                            <td>drcks.mvsu@gmail.com</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h6>Departmental Non-Academic Members</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Name</th>
                            <th>Post</th>
                            <th>Contact No.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Shri Sita Ram</td>
                            <td>Clerk</td>
                            <td>8950765174</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
};

export default function SanskritBhashaDakshataDiploma_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);
    const [activeId, setActiveId] = useState(departments[0].id);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId]);
        setActiveId(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">Sanskrit Language Proficiency Diploma</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id
                                ? "bg-primary text-white"
                                : "bg-white text-dark"
                                }`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >

                <div>{currentContent}</div>
            </main>
        </div>
    );
}